import { JobTimeoutError } from "../utils/errors.js";

export async function withTimeout<T>(
  work: (signal: AbortSignal) => Promise<T>,
  timeoutMs: number,
  externalSignal?: AbortSignal
): Promise<T> {
  const controller = new AbortController();
  const abort = (reason?: unknown) => controller.abort(reason);
  if (externalSignal?.aborted) abort(externalSignal.reason);
  externalSignal?.addEventListener("abort", () => abort(externalSignal.reason), { once: true });

  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      const error = new JobTimeoutError(`Job timed out after ${timeoutMs}ms`);
      abort(error);
      reject(error);
    }, timeoutMs);
    timer.unref?.();
  });

  try {
    return await Promise.race([work(controller.signal), timeout]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}
